import { Link } from "react-router-dom";
import { Section, Pill } from "./PortalPage";
import { fmtMoney, fmtDate, INVOICE_STATUS } from "./portalUtils";
import { Receipt } from "@phosphor-icons/react";

/* Compact invoice summary shown on job / emergency / project detail pages in the client portal. */
export function InvoiceSummaryCard({ invoices, testid = "linked-invoice" }) {
  const list = (Array.isArray(invoices) ? invoices : [invoices]).filter(Boolean);
  if (list.length === 0) return null;
  return (
    <Section title={list.length > 1 ? `Invoices (${list.length})` : "Invoice"} testid={testid}>
      <ul className="space-y-3">
        {list.map((inv) => (
          <li key={inv.id} className="flex items-center justify-between gap-2" data-testid={`${testid}-${inv.id}`}>
            <div className="min-w-0">
              <Link to={`/portal/invoices/${inv.id}`} className="text-xs font-mono text-muted-foreground hover:text-primary hover:underline" data-testid={`${testid}-view-${inv.id}`}>{inv.reference || inv.invoice_number}</Link>
              <p className="text-lg font-bold font-[Chivo]">{fmtMoney(inv.amount)}</p>
              {inv.due_date && !["paid", "cancelled"].includes(inv.status) && <p className="text-[10px] text-muted-foreground">Due {fmtDate(inv.due_date)}</p>}
            </div>
            <Pill map={INVOICE_STATUS} value={inv.status} />
          </li>
        ))}
      </ul>
      <Link to={list.length === 1 ? `/portal/invoices/${list[0].id}` : "/portal/invoices"} className="text-[11px] text-primary hover:underline mt-3 inline-flex items-center gap-1"><Receipt size={12} /> {list.length === 1 ? "View invoice" : "View invoices"} &amp; pay</Link>
    </Section>
  );
}
